import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

export const NotificationsScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <SkeletonList count={8} gap={0}>
      <View style={styles.itemContainer}>
        <SkeletonListItem
          avatar
          avatarSize={36}
          lines={3}
          lineWidths={[160, '80%', 80]}
          lineHeight={13}
        />
      </View>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  itemContainer: {
    paddingVertical: 10,
  },
});
